<template>
    <el-form ref="export" :model="form" label-width="120px" v-loading="loading">
        <div id="export-form" v-show="!showResult">
            <el-form-item label="导出文件名" prop="displayName" :rules="displayNameRules">
                <el-input class="export-formItem" v-model="form.displayName" />
            </el-form-item>
            <el-form-item required label="选择数据" prop="dataRange">
                <el-select class="export-formItem" v-model="form.dataRange" placeholder="请选择要导出的数据">
                    <el-option v-for="option in dataRangeOptions" 
                        :key="option.Value"
                        :label="option.Text" 
                        :value="option.Value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择字段" prop="checkedFields">
                <div class="el-transfer export-formItem">
                    <div class="el-transfer-panel">
                        <p class="el-transfer-panel__header">
                            <el-checkbox
                                v-model="checkAll"
                                :indeterminate="isIndeterminate"
                                @change="handleCheckAllChange">   
                                全部字段 
                            </el-checkbox>
                        </p>
                        <div class="body">
                            <el-scrollbar height="200px">
                                <el-tree ref="exportTreeItem"
                                    @check="nodeCheck"
                                    :data="exportFieldsData"
                                    show-checkbox
                                    default-expand-all
                                    node-key="Name"
                                    highlight-current
                                    :props="defaultProps"
                                />
                            </el-scrollbar>
                        </div>
                    </div>
                </div>
            </el-form-item>
            <div style="display: -webkit-flex; display: flex;justify-content:center">
                <el-checkbox style="margin-right: 50px;" v-model="addContentItemId" label="同时导出数据Id">
                    同时导出数据Id
                </el-checkbox>
                <el-button @click="cancel">取消</el-button>
                <el-button @click="sumbit" type="success" :disabled="form.checkedFields.length == 0">导出</el-button>
            </div>
        </div>
        <div id="export-result" v-show="showResult">
            <el-result
                icon="success"
                title="完成">
                <template #extra>
                 「{{ form.displayName }}」导出文件已准备完成。请尽快<el-link type="primary" :href="path" target="_blank">下载</el-link>
                </template>
            </el-result>
        </div>
    </el-form>
</template>

<style scope>
    .import-dialog{
        min-width: 550px;
    }

    #export-form{
        width: 500px !important;
        margin: auto !important;
    }

    .export-formItem{
        width:300px !important;
    }
    .export-formItem .el-transfer-panel{
        width:300px !important;
    }

    .el-transfer-panel__header{
        padding-left: 24px !important;
    }
    .body{
        border-left: 1px solid var(--el-transfer-border-color);
        border-right: 1px solid var(--el-transfer-border-color);
        border-bottom: 1px solid var(--el-transfer-border-color);
        border-bottom-left-radius: var(--el-transfer-border-radius);
        border-bottom-right-radius: var(--el-transfer-border-radius);
        height: 200px;
    }
    
</style>


<script>
    import { ExportDataRange } from '.'
    import { exportExcel } from "../../apis/httpHelper"
    import { JSONReplacer } from '../../common/commonHelper';
    import { startsWith, countBy } from "lodash"


    export default {
        name:"ExportItem",
        props:{
            contentType:{
                type:String,
                required:true
            },
            sort:Array,
            filter:Object,
            orginalFilter:Object,
            displayName:String,
            exportFields:Array
        },
        data:function(){
            return {
                "defaultProps":{
                    children: 'Children',
                    label: 'DisplayName',
                },
                "allCheck":[],
                "allCheckNodes":[],
                "form":{
                    "displayName":"",
                    "checkedFields":[],
                    "dataRange":ExportDataRange.Depart 
                },
                "loading":false,
                "showResult":false,
                "path":"",
                "displayNameRules":[{ required: true, message: '请填写一个文件名以便导出', trigger: 'blur' }],
                "checkAll":true,
                "isIndeterminate":false,
                "dataRangeOptions":[
                    {
                        "Text":"全部数据",
                        "Value":ExportDataRange.All
                    },
                    {
                        "Text":"过滤后数据",
                        "Value":ExportDataRange.Depart
                    }
                ],
                "addContentItemId":false,
                "exportFieldsData":{}
            }
        },
        emits:[
            'cancel',
            'success'
        ],
        created:function(){
            this.exportFieldsData = this.exportFields.map(x=> this.handleHasParentExportFields(x, ""));
            this.form.checkedFields = JSON.parse(JSON.stringify(this.allCheck));
            this.form.displayName = this.displayName;
        },
        mounted() {
            this.$nextTick(function () {
                this.$refs.exportTreeItem.setCheckedKeys(this.form.checkedFields);
                let height = document.querySelector("#export-form").offsetHeight;
                document.querySelector("#export-result").style.height = height + "px";
            })
        },
        methods:{
            handleHasParentExportFields:function(data, parentName){
                let newData = {
                    Name:(parentName == "" ? "" : (parentName + ".")) + data.Name,
                    Type:data.Type,
                    DisplayName:data.DisplayName,
                    Children:data.Children || []
                };
                this.allCheck.push(newData.Name);
                this.allCheckNodes.push(newData);
                if(newData.Children.length > 0){
                    newData.Children = newData.Children.map(x=> this.handleHasParentExportFields(x, newData.Name))
                }
                return newData;
            },

            handleCheckAllChange:function(val){
                let checkedFields = val ? JSON.parse(JSON.stringify(this.allCheck)) : [];
                this.form.checkedFields = checkedFields;
                this.$refs.exportTreeItem.setCheckedKeys(this.form.checkedFields);
                this.isIndeterminate = false;
            },

            nodeCheck:function(node, tree){
                this.form.checkedFields = tree.checkedKeys;
                const checkedCount = this.form.checkedFields.length;
                this.checkAll = checkedCount === this.allCheck.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.allCheck.length;
            },

            cancel:function(){
                this.$emit('cancel');
            },

            buildExport:function(checkedFields, checkedFieldsMap){
                let exportFields = JSON.parse(JSON.stringify(this.exportFields));
                checkedFields.forEach((field)=>{
                    let next = exportFields;
                    let cell = checkedFieldsMap.get(field.join("."));
                    let lastIndex = field.length - 1;
                    for(let i = 0;i < field.length; i++){
                        let result = next.find(x=>x.Name == field[i]);
                        next = result.Children || [];
                        if(i == lastIndex){
                            result.Active = true;
                            result.ColSpan = cell.ColSpan,
                            result.RowSpan = cell.RowSpan
                        }
                    }
                });
                let result = {
                    "Children":exportFields
                };
                this.removeUnActiveNode(result);
                return result.Children;
            },

            removeUnActiveNode:function(exportField){
                exportField.Children = exportField.Children || [];
                if(exportField.Children.length > 0){
                    exportField.Children = exportField.Children.filter(x=>x.Active);
                    exportField.Children.forEach(x=>{
                        this.removeUnActiveNode(x);
                    })
                }
            },

            getNodesByLevel:function(checkedFields, deep){
                let filterResult = checkedFields.filter(x=> x.length >= (deep+1));
                return filterResult.map(x=> (x||[]).slice(0, deep+1));
            },

            buildCellMap:function(){
                let checkedFields = this.form.checkedFields.map(x=>x.split("."));
                let checkedFieldsCopy = this.form.checkedFields.map(x=>x.split("."));

                //根据层级把未添加的选中数据添加进来
                let maxDeep = Math.max(...(checkedFields.map(x=>x.length)));
                //因为最后一层本来就存在于数据列表checkedFieldsCopy中，所以排除最后一层的的执行
                for(let deep = 0; deep < (maxDeep-1); deep++){
                    let levelNodes = this.getNodesByLevel(checkedFields, deep);
                    if(levelNodes.length>0){
                        checkedFieldsCopy = checkedFieldsCopy.concat(levelNodes);
                    }
                }

                //去重
                let stringCheckedFields = Array.from(new Set(checkedFieldsCopy.map(x=> x.join("."))));
                let mapObject = {};
                checkedFields = [];
                stringCheckedFields.forEach(x=> {
                    mapObject[x] = x.split(".")
                    checkedFields.push(x.split("."));
                });

                let checkedFieldsMap = new Map();
                stringCheckedFields.forEach(x=>{
                    //找到所有的开头是当前的子元素数据
                    let includesCurrent =  stringCheckedFields.filter(fieldString=> startsWith(fieldString, x + "."));
                    let colSpan = 1;
                    let rowSpan = maxDeep - mapObject[x].length + 1;
                    if(includesCurrent.length > 0){
                        let includesCurrentArrayUnion = new Array();
                        includesCurrent.forEach(x=>
                        {
                            let arrayData = x.split(".");
                            includesCurrentArrayUnion = includesCurrentArrayUnion.concat(arrayData);
                        });
                        
                        let countResult = countBy(includesCurrentArrayUnion);
                        //最后一个节点永远不重复
                        colSpan = Object.values(countResult).filter(x=> x == 1).length;
                        rowSpan = 1;
                    }
                    
                    checkedFieldsMap.set(x, {
                        ColSpan: colSpan,
                        RowSpan: rowSpan
                    });
                });
                return {
                    checkedFields: checkedFields,
                    checkedFieldsMap: checkedFieldsMap,
                    maxDeep: maxDeep
                };
            },

            sumbit:function(){
                this.$refs.export.validate((valid, fields) => {
                    if (valid) {
                        let checkedFieldsObj = this.buildCellMap();
                        
                        let exportFields = this.buildExport(checkedFieldsObj.checkedFields, checkedFieldsObj.checkedFieldsMap);

                        this.loading = true;
                        
                        let filter = this.form.dataRange == ExportDataRange.All ? this.orginalFilter : {"logic":"and","filters":[this.orginalFilter, this.filter]};
                        
                        if(this.addContentItemId){
                            exportFields.unshift({ "Name":"ContentItemId","DisplayName":"ContentItemId","ColSpan":1, "RowSpan": checkedFieldsObj.maxDeep});
                        }
                        console.log(exportFields);
                        exportFields.forEach(x=>{
                            x.Parent = this.contentType 
                        })
                        
                        exportExcel(
                            this.contentType,
                            JSON.stringify(exportFields),
                            this.sort,
                            JSON.stringify(filter, JSONReplacer),
                            this.form.displayName
                        ).then(x=>{
                                this.path = x.Result;
                                this.showResult = true;
                                this.loading = false;
                            })
                    }
                })
            }
        }
    }
</script>